import { T } from "@/locales";

export const columns = [
  {
    title: T("序号"),
    dataIndex: "index",
    customRender: (value, item, index) => index + 1,
    fixed: "left",
    width: 60,
  },
  {
    title: T("货品名称"),
    dataIndex: "material_name",
    width: 150,
    fixed: "left",
    ellipsis: true,
  },
  {
    title: T("库位"),
    dataIndex: "location",
    width: 200,
    scopedSlots: { customRender: "location" },
  },
  {
    title: T("收货数量"),
    dataIndex: "receipt_quantity",
    width: 120,
    scopedSlots: { customRender: "receipt_quantity" },
  },
  {
    title: T("收货重量(吨)"),
    dataIndex: "total_weight",
    width: 120,
    scopedSlots: { customRender: "total_weight" },
  },
  {
    title: T("收货面积(平方米)"),
    dataIndex: "total_area",
    width: 140,
    scopedSlots: { customRender: "total_area" },
  },
  {
    title: T("收货体积(立方米)"),
    dataIndex: "total_volume",
    width: 140,
    scopedSlots: { customRender: "total_volume" },
  },
  // {
  //   title: T("计费量"),
  //   dataIndex: "charge_value",
  //   key: "charge_value",
  //   width: 120,
  //   scopedSlots: { customRender: "charge_value" },
  // },
  {
    title: T("批次编号"),
    dataIndex: "batch_number",
    width: 180,
    scopedSlots: { customRender: "batch_number" },
  },
  {
    title: T("容器编号"),
    dataIndex: "pallet_number",
    width: 180,
    scopedSlots: { customRender: "pallet_number" },
  },
  {
    title: T("质检状态"),
    dataIndex: "status",
    key: "quality_inspection_status",
    width: 120,
    scopedSlots: { customRender: "status" },
  },
  {
    title: T("货品编号"),
    dataIndex: "material_number",
    width: 150,
  },
  {
    title: T("待收货数量"),
    dataIndex: "remain_quantity",
    width: 120,
  },
  {
    title: T("生产日期"),
    width: 120,
    dataIndex: "production_date",
    scopedSlots: { customRender: "production_date" },
  },
  {
    title: T("单位"),
    dataIndex: "material_unit",
    width: 80,
  },
  // {
  //   title: T("计费单位"),
  //   width: 120,
  //   dataIndex: "charge_unit_display",
  //   key: "charge_unit",
  // },
  {
    title: T("规格"),
    dataIndex: "material_spec",
    width: 120,
  },
  {
    title: T("启用保质期"),
    dataIndex: "enable_shelf_life",
    width: 160,
    customRender: (value, item, index) => {
      return value ? T("启用") : T("关闭");
    },
  },
  {
    title: T("保质期天数"),
    dataIndex: "shelf_life_days",
    width: 120,
  },
  {
    title: T("托盘尺寸"),
    dataIndex: "pallet_size",
    width: 120,
  },
  {
    title: T("备注"),
    dataIndex: "remark",
    width: 120,
  },
  {
    title: T("操作"),
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: 60,
    fixed: "right",
  },
];
